import * as React from 'react';

const SvgChevronRightOutline = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "m14.168 12-5.61 5.582L9.967 19 17 12l-7-7-1.414 1.415L14.168 12Z", fill: "currentColor" })));

export { SvgChevronRightOutline as default };
